import { Constants } from '../common/util';
import { DEFAULT_MESSSAGE } from '../model/common';
import { FormCustomValidation } from './custom_validation';
import { customValidateFuntionArray } from './custom_validation.service';
import { EncryptAndDecrypt } from './encrypt_deccrypt';
import { isCustomValidator, isInt, isMaxLength, isMinLength, isPattern, isRequired, Validation, } from './validation';
var FormValidation = /** @class */ (function () {
    function FormValidation(config) {
        this.config = config;
        this.encryptAndDecrypt = new EncryptAndDecrypt(this.config);
        this.formCustomValidation = new FormCustomValidation();
        this.$form = {};
        this.rules = {};
        this.allFormRules = {};
        this.eventListnersList = [];
    }
    FormValidation.prototype.init = function (formELement, data) {
        var _this_1 = this;
        if (this.eventListnersList.length) {
            this.eventListnersList.forEach(function (listnerDetail) {
                if (listnerDetail.element) {
                    listnerDetail.element.removeEventListener(listnerDetail.event, listnerDetail.handlerFunction);
                }
            });
            this.eventListnersList = [];
        }
        var elements = formELement.querySelectorAll('[rsmonitor], [data-rsmonitor]');
        var formkey = formELement.getAttribute('rsactionoriginator') || formELement.getAttribute('data-rsactionoriginator');
        this.serviceCallResponseData = data;
        this.createRules(elements, formkey);
        console.log(this.rules);
        this.$form[formkey] = formELement;
        var rsValidatorEventType = formELement.querySelectorAll('[rsvalidatoreventtype], [data-rsvalidatoreventtype]');
        var eventType = [];
        rsValidatorEventType.forEach(function (element) {
            var type = element.getAttribute('rsvalidatoreventtype') || element.getAttribute('data-rsvalidatoreventtype');
            if (type) {
                if (type.indexOf(',')) {
                    var types = type.split(',');
                    types.forEach(function (evType) {
                        evType = evType.replace(' ', '');
                        eventType.push(evType);
                    });
                }
                else {
                    eventType.push(type);
                }
                var uniqEventType = eventType.filter(function (item, pos) {
                    return eventType.indexOf(item) == pos;
                });
                uniqEventType.forEach(function (type) {
                    _this_1.setterEventListener(element, type, formkey);
                });
                // eventType.push(type);
            }
        });
        // const uniqEventType = eventType.filter(function (item, pos) {
        //   return eventType.indexOf(item) == pos;
        // });
        // uniqEventType.forEach((type: string) => {
        //   this.setterEventListener(formELement, type, formkey);
        // });
    };
    FormValidation.prototype.setterEventListener = function (formELement, type, formkey) {
        var _this = this;
        var formSubmitEvent = function () {
            var field = formELement;
            var rsmonitor = field.getAttribute('rsmonitor') || field.dataset.rsmonitor;
            var rsvalidatoreventtype = field.getAttribute('rsvalidatoreventtype') || field.dataset.rsvalidatoreventtype;
            if ((rsmonitor && type === rsvalidatoreventtype) ||
                (rsvalidatoreventtype && rsvalidatoreventtype.indexOf(type) > -1)) {
                var isSubmit = field.getAttribute('rssubmit') || field.dataset.rssubmit;
                if (!isSubmit || isSubmit === 'false' || isSubmit === 'undefined' || isSubmit.length === 0) {
                    isSubmit = false;
                }
                else {
                    isSubmit = true;
                }
                if (!isSubmit) {
                    var elem = field;
                    _this.rulesForElement(elem);
                    var rulesElement = _this.rulesForElement(elem);
                    _this.updateRules(rsmonitor, formkey, rulesElement);
                    var errorData = _this.validateField(elem, formkey);
                    if (errorData && Object.keys(errorData).length > 0) {
                        var targetElementList = [];
                        targetElementList[rsmonitor] = elem;
                        _this.setError(errorData, formkey, targetElementList);
                    }
                    else {
                        _this.clearErrorField(elem, formkey);
                    }
                }
            }
        };
        formELement.addEventListener(type, formSubmitEvent, false);
        this.eventListnersList.push({
            element: formELement,
            event: type,
            handlerFunction: formSubmitEvent,
        });
    };
    FormValidation.prototype.rulesForElement = function (item) {
        var validatorRulesList = [];
        var rsRequired = this.covertToJson(item.getAttribute('rsrequired') || item.getAttribute('data-rsrequired'));
        var rsPattern = this.covertToJson(item.getAttribute('rspattern') || item.getAttribute('data-rspattern'));
        var rsMinLength = this.covertToJson(item.getAttribute('rsminlength') || item.getAttribute('data-rsminlength'));
        var rsMaxLength = this.covertToJson(item.getAttribute('rsmaxlength') || item.getAttribute('data-rsmaxlength'));
        var rsInt = this.covertToJson(item.getAttribute('rsint') || item.getAttribute('data-rsint'));
        var rsCustomValidator = item.getAttribute('rscustomvalidator') || item.getAttribute('data-rscustomvalidator');
        if (rsRequired && (rsRequired.val === 'true' || rsRequired.val === true)) {
            var msg = this.getMessage(rsRequired.message, 'data-rsrequired', item);
            validatorRulesList.push(isRequired(msg));
        }
        if (rsInt && (rsInt.val === 'true' || rsInt.val === true)) {
            var msg = this.getMessage(rsInt.message, 'data-rsint', item);
            validatorRulesList.push(isInt(msg));
        }
        if (rsPattern && rsPattern.val) {
            var msg = this.getMessage(rsPattern.message, 'data-rspattern', item);
            validatorRulesList.push(isPattern(rsPattern.val, msg));
        }
        if (rsMinLength && rsMinLength.val) {
            var msg = this.getMessage(rsMinLength.message, 'data-rsminlength', item);
            validatorRulesList.push(isMinLength(rsMinLength.val, msg));
        }
        if (rsMaxLength && rsMaxLength.val) {
            var msg = this.getMessage(rsMaxLength.message, 'data-rsmaxlength', item);
            validatorRulesList.push(isMaxLength(rsMaxLength.val, msg));
        }
        if (rsCustomValidator && rsCustomValidator !== 'null' && rsCustomValidator !== 'undefined') {
            var lengthValue = rsCustomValidator.match(/\[.*\]/);
            var arg = null;
            var UpdatedVal = rsCustomValidator.trim();
            if (lengthValue) {
                arg = lengthValue.toString().slice(1, -1);
                try {
                    if (arg.indexOf("" + Constants.MODEL) > -1) {
                        arg = this.getDataFromModel(arg, this.serviceCallResponseData);
                    }
                    else {
                        if (arg && arg !== 'undefined') {
                            arg = arg.replace(/(\s*?{\s*?|\s*?,\s*?)(['"])?([a-zA-Z0-9]+)(['"])?:/g, '$1"$3":');
                            arg = arg.replace(/'/g, '"');
                            arg = JSON.parse(arg);
                        }
                        else if (arg === 'undefined') {
                            arg = undefined;
                        }
                    }
                }
                catch (error) {
                    throw Error(rsCustomValidator + ', Argument is not valid');
                }
                UpdatedVal = rsCustomValidator.replace(lengthValue[0], '');
            }
            validatorRulesList.push(isCustomValidator(UpdatedVal, arg, item));
        }
        return validatorRulesList;
    };
    FormValidation.prototype.getDataFromModel = function (modelKey, model) {
        var q = modelKey.replace(Constants.MODEL + ".", '');
        var key = q.split('[').join('.').split(']').join('');
        var value = key.split('.').reduce(function (v, k) { return (v || {})[k]; }, model);
        return value;
    };
    FormValidation.prototype.updateRules = function (name, formkey, rules) {
        this.allFormRules[formkey][name] = rules;
    };
    FormValidation.prototype.createRules = function (elements, formkey) {
        this.allFormRules[formkey] = {};
        this.rules = {};
    };
    FormValidation.prototype.getMessage = function (message, type, el) {
        var element = el;
        var htmlTextInputTypes = [
            'date',
            'datetime-local',
            'email',
            'file',
            'month',
            'number',
            'password',
            'search',
            'tel',
            'text',
            'time',
            'url',
            'week',
            'textarea',
        ];
        if (message && message.length > 0) {
            return message;
        }
        else {
            if (type === 'data-rsrequired') {
                if (element.type === 'checkbox' || element.dataset.type === 'checkbox')
                    return DEFAULT_MESSSAGE.messageValueMissingCheckbox;
                if (htmlTextInputTypes.includes(element.type))
                    return DEFAULT_MESSSAGE.messageValueMissing;
                if (element.type === 'radio' || element.dataset.type === 'radio')
                    return DEFAULT_MESSSAGE.messageValueMissingRadio;
                if (element.tagName === 'SELECT' || element.dataset.tagname === 'SELECT')
                    return DEFAULT_MESSSAGE.messageValueMissingSelect;
            }
            if (type === 'data-rsint') {
                return DEFAULT_MESSSAGE.messageBadInput;
            }
            if (type === 'data-rspattern') {
                return DEFAULT_MESSSAGE.messagePatternMismatch;
            }
            if (type === 'data-rsminlength') {
                if (element.type === 'checkbox' ||
                    element.tagName === 'SELECT' ||
                    element.dataset.type === 'checkbox' ||
                    element.dataset.tagname === 'SELECT') {
                    return DEFAULT_MESSSAGE.messageRangeUnderflow;
                }
                else {
                    return DEFAULT_MESSSAGE.messageTooShort;
                }
            }
            if (type === 'data-rsmaxlength') {
                if (element.type === 'checkbox' ||
                    element.tagName === 'SELECT' ||
                    element.dataset.type === 'checkbox' ||
                    element.dataset.tagname === 'SELECT') {
                    return DEFAULT_MESSSAGE.messageRangeOverflow;
                }
                else {
                    return DEFAULT_MESSSAGE.messageTooLong;
                }
            }
        }
    };
    FormValidation.prototype.covertToJson = function (jsonStr) {
        var regex = /(\w+):([^\s]+)/g;
        if (jsonStr && regex.test(jsonStr)) {
            try {
                console.log(jsonStr);
                jsonStr = jsonStr.replace(/(\s*?{\s*?|\s*?,\s*?)(['"])?([a-zA-Z0-9]+)(['"])?:/g, '$1"$3":');
                var modifyStr = jsonStr.replace(/'/g, '"');
                return JSON.parse(modifyStr);
            }
            catch (error) {
                throw Error('Attribute value not valid');
            }
        }
        else {
            var obj = {
                val: jsonStr,
            };
            return obj;
        }
    };
    FormValidation.prototype.validateField = function (elem, formkey) {
        var name = elem.getAttribute('rsmonitor') || elem.getAttribute('data-rsmonitor');
        var rule = {};
        if (name) {
            rule[name] = this.allFormRules[formkey][name];
            var value = {};
            var elementVal = void 0;
            if (elem.tagName === 'SELECT' || elem.dataset.tagname === 'SELECT') {
                var selectedOptions = [];
                if (elem) {
                    if (elem.dataset.tagname === 'SELECT') {
                        if (elem.value) {
                            selectedOptions.push(elem.value);
                        }
                    }
                    else {
                        selectedOptions = Array.from(elem.options)
                            .filter(function (option) {
                            if (option.value) {
                                return option.selected;
                            }
                        })
                            .map(function (option) {
                            if (option.value) {
                                return option.value;
                            }
                        });
                    }
                }
                elementVal = selectedOptions;
            }
            else if (elem.type === 'checkbox' ||
                elem.type === 'radio' ||
                elem.dataset.type === 'checkbox' ||
                elem.dataset.type === 'radio') {
                var el = elem.dataset.name ? elem.dataset.name : elem.getAttribute('name');
                var radio = elem.dataset.name
                    ? document.querySelectorAll('[data-name="' + ("" + el) + '"]')
                    : document.getElementsByName("" + el);
                var selectedValues = Array.from(radio)
                    .filter(function (option) {
                    return option.checked;
                })
                    .map(function (option) {
                    return option.value;
                });
                elementVal = selectedValues;
            }
            else {
                elementVal = elem.value;
            }
            value[name] = elementVal;
            var errorData = new Validation(rule).validate(value);
            console.log('rule', rule);
            console.log('errorData', errorData);
            return errorData;
        }
    };
    FormValidation.prototype.validateForm = function (Data, formKey, targetElementList) {
        var _this_1 = this;
        var updatedData = Object.assign({}, Data);
        Object.keys(Data).forEach(function (key) {
            if (updatedData[key] && typeof updatedData[key] === 'string') {
                var splitVal = updatedData[key].match('\\{(.*)\\}');
                if (splitVal) {
                    var ciphertext = splitVal[1];
                    var encryptedVal = updatedData[key].replace(splitVal[0], '');
                    var deCrypteddVal = _this_1.encryptAndDecrypt.enCryptDeCryptValue(encryptedVal, customValidateFuntionArray.sessionId, false);
                    if (ciphertext && ciphertext === 'cipher' && deCrypteddVal) {
                        updatedData[key] = deCrypteddVal;
                    }
                }
            }
        });
        console.log('Rules List', this.allFormRules[formKey]);
        var result = new Validation(this.allFormRules[formKey]).validate(updatedData);
        console.log('errors form submit', result);
        this.clearAllErrorField(formKey);
        if (Object.keys(result).length) {
            var el = targetElementList;
            this.setError(result, formKey, el);
            this.updateFormErrorHtml(result, formKey);
            return false;
        }
        else {
            this.updateFormErrorHtml(result, formKey);
            return true;
        }
    };
    FormValidation.prototype.setError = function (errorData, formkey, element) {
        var _this_1 = this;
        Object.keys(errorData).forEach(function (key) {
            var errorDiveId = element[key].getAttribute('rsvalidationerror') || element[key].getAttribute('data-rsvalidationerror');
            var elements = _this_1.$form[formkey].querySelectorAll('[rsvalidationerror="' + errorDiveId + '"], [data-rsvalidationerror="' + errorDiveId + '"]');
            elements.forEach(function (elem) {
                var className = elem.getAttribute('rsinvalidclass') || elem.getAttribute('data-rsinvalidclass');
                if (className) {
                    elem.classList.add(className);
                }
                if (elem.hasAttribute('invalid-message')) {
                    elem.setAttribute('invalid-message', errorData[key]);
                }
                if (elem.hasAttribute('invalid')) {
                    elem.setAttribute('invalid', true);
                }
                if (elem.hasAttribute('data-rssetparentinvalid')) {
                    var elMonitorValue = elem.getAttribute('data-rssetparentinvalid');
                    var elementsIn = _this_1.$form[formkey].querySelectorAll('[data-rssetinvalid="' + elMonitorValue + '"]');
                    elementsIn.forEach(function (el) {
                        el.setAttribute('invalid', true);
                        el.setAttribute('invalid-message', errorData[key]);
                    });
                }
            });
            if (errorDiveId) {
                var errorDiv = _this_1.$form[formkey].querySelector('[id="' + errorDiveId + '"]');
                if (errorDiv) {
                    errorDiv.innerHTML = errorData[key];
                    errorDiv.classList.add('rs-visible');
                }
            }
        });
    };
    FormValidation.prototype.updateFormErrorHtml = function (result, formKey) {
        var elements = document.querySelectorAll('[rsformerror="' + formKey + '"], [data-rsformerror="' + formKey + '"]');
        if (elements && elements.length > 0) {
            if (result && Object.keys(result).length > 0) {
                var html_1 = '<div>';
                Object.keys(result).forEach(function (key) {
                    html_1 += "<p><span>" + key + "</span>: " + result[key] + "</p>";
                });
                html_1 += "</div>";
                elements[0].innerHTML = html_1;
                elements[0].classList.add('rs-visible');
            }
            else {
                elements[0].innerHTML = '';
                elements[0].classList.remove('rs-visible');
            }
        }
    };
    FormValidation.prototype.clearAllErrorField = function (formkey) {
        var _this_1 = this;
        var elements = this.$form[formkey].querySelectorAll('[rsmonitor], [data-rsmonitor]');
        var errorDiv = this.$form[formkey].querySelectorAll('[rsvalidationerror], [data-rsvalidationerror]');
        elements.forEach(function (elem) {
            var className = elem.getAttribute('rsinvalidclass') || elem.getAttribute('data-rsinvalidclass');
            if (className) {
                elem.classList.remove(className);
            }
            if (elem.hasAttribute('invalid-message')) {
                elem.setAttribute('invalid-message', '');
            }
            if (elem.hasAttribute('invalid')) {
                elem.setAttribute('invalid', false);
            }
            if (elem.hasAttribute('data-rssetparentinvalid')) {
                var elMonitorValue = elem.getAttribute('data-rssetparentinvalid');
                var elementsIn = _this_1.$form[formkey].querySelectorAll('[data-rssetinvalid="' + elMonitorValue + '"]');
                elementsIn.forEach(function (el) {
                    el.setAttribute('invalid', false);
                    el.setAttribute('invalid-message', '');
                });
            }
        });
        errorDiv.forEach(function (errDiv) {
            var errorDiveId = errDiv.getAttribute('rsvalidationerror') || errDiv.getAttribute('data-rsvalidationerror');
            var container = _this_1.$form[formkey].querySelector('[id="' + errorDiveId + '"]');
            if (container) {
                container.innerHTML = '';
                container.classList.remove('rs-visible');
            }
        });
    };
    FormValidation.prototype.clearErrorField = function (elm, formkey) {
        var _this_1 = this;
        var name = elm.getAttribute('rsvalidationerror') || elm.getAttribute('data-rsvalidationerror');
        var className = elm.getAttribute('rsinvalidclass') || elm.getAttribute('data-rsinvalidclass');
        var elements = this.$form[formkey].querySelectorAll('[rsvalidationerror="' + name + '"], [data-rsvalidationerror="' + name + '"]');
        elements.forEach(function (elem) {
            if (className) {
                elem.classList.remove(className);
            }
            if (elem.hasAttribute('invalid-message')) {
                elem.setAttribute('invalid-message', '');
            }
            if (elem.hasAttribute('invalid')) {
                elem.setAttribute('invalid', false);
            }
            if (elem.hasAttribute('data-rssetparentinvalid')) {
                var elMonitorValue = elem.getAttribute('data-rssetparentinvalid');
                var elementsIn = _this_1.$form[formkey].querySelectorAll('[data-rssetinvalid="' + elMonitorValue + '"]');
                elementsIn.forEach(function (el) {
                    el.setAttribute('invalid', false);
                    el.setAttribute('invalid-message', '');
                });
            }
        });
        var errorDiveId = elm.getAttribute('rsvalidationerror') || elm.getAttribute('data-rsvalidationerror');
        var container = this.$form[formkey].querySelector('[id="' + errorDiveId + '"]');
        if (container) {
            container.innerHTML = '';
        }
    };
    return FormValidation;
}());
export { FormValidation };
//# sourceMappingURL=form_validation.js.map